import { MeshLambertMaterial as u } from "three";
import { RG_TYPE as a, RG_TECH_CLASS as p } from "@project-rouge/rg-core";
const l = new u({ vertexColors: !0 }), o = new u({ vertexColors: !0, transparent: !0 });
function m(r) {
  return /* @__PURE__ */ new Map([
    [
      "opaque",
      {
        material: l,
        visible: (t) => {
          var n, i;
          const e = t.userData;
          if (e.alpha !== 1 || !r.Unit && e.type === a.Module && ((n = e.parent) == null ? void 0 : n.type) === a.Apartment)
            return !1;
          if ((!r.Amenities || !r.Services) && e.type === a.Module && ((i = e.parent) == null ? void 0 : i.type) === a.TechnicalSpace) {
            const s = e.parent;
            if (!r.Amenities && s.data.instance.spaceClass === p.Amenity || !r.Services && s.data.instance.spaceClass === p.Service)
              return !1;
          }
          return !0;
        }
      }
    ],
    [
      "transparent",
      {
        material: o,
        visible: (t) => !(!t.alpha || t.alpha === 1)
      }
    ]
  ]);
}
export {
  m as getFeLayers
};
//# sourceMappingURL=index.js.map
